'use client';

import { Loader } from '@mantine/core';
import type { ApiStatus } from '@/hooks/useApiStatus';
import classes from './ConnectivityOverlay.module.css';

interface ConnectivityOverlayProps {
  status: ApiStatus;
}

export function ConnectivityOverlay({ status }: ConnectivityOverlayProps) {
  const visible = status === 'checking' || status === 'offline';
  const message =
    status === 'checking' ? 'Connecting to server\u2026' : 'Server unavailable, retrying\u2026';

  return (
    <div className={`${classes.overlay} ${visible ? classes.visible : ''}`}>
      <div className={classes.content}>
        <Loader size="sm" />
        <span className={classes.message}>{message}</span>
      </div>
    </div>
  );
}
